import { NgModule } from '@angular/core';

import { DashboardRoutingModule } from './dashboard-routing.module';
import { CommonModule } from '@angular/common';

import { DashboardComponent } from './components/dashboard/dashboard.component';
import { NgForOf } from "@angular/common";

@NgModule({
  imports: [DashboardRoutingModule, NgForOf, CommonModule],
  declarations: [DashboardComponent]
})

export class DashboardModule {

}
